// extracted by mini-css-extract-plugin
export default {"main":"HelpRequests_main__rWdoB","optionsMenu":"HelpRequests_optionsMenu__e-59h","contentsPage":"HelpRequests_contentsPage__HbtLI","copyRight":"HelpRequests_copyRight__YAyjz"};